import styled from 'styled-components';

const LegendUL = styled.ul`
	position: relative;
	width: 104px;
	top: 2px;
	left: 0px;
	margin: 0;
	padding: 6px 2px;
	list-style: none;
	transition: transform 0.2s ease;
	z-index: 20;


	li{
			padding: 5px 6px 5px 8px;
			cursor: pointer;
			display: flex;
			align-items: center;
			gap: 8px;
			font-size: 13px;
			font-weight: 500;
			color: var(--textColor);
			background: color-mix(in srgb, var(--defaultBgColor) 80%, transparent);
			margin-bottom: 2px;
			border-radius: 3px;
			

			span{
				width: 16px;
				min-width: 16px;
				display: flex;
				position: relative;
				top: 0px;
				height: 16px;
				border-radius: 2px;
				border: 2px solid var(--btnLabel);
			}
			label{
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				vertical-align: middle;
			}	

			&:last-child {
				margin-bottom: 0;
			}
	}`;

export {
	LegendUL
};